export default __webpack_public_path__ + "static/media/italygot-mobile-2.7196cb75.png";